<script setup lang='ts'>
import type { CreatAgrmForm } from 'src/types/agreement'
import { reactive, ref, watch } from 'vue'

// 定义组件的属性
const props = defineProps<{
  // 表单数据
  form: CreatAgrmForm
}>()

// 定义组件事件
const emit = defineEmits(['update:form'])

// 创建本地表单数据
const localForm = reactive<CreatAgrmForm>({
  co_name: '',
  corp_name: '',
  addr: '',
})

const rules = {
  corp_name: [
    { required: true, message: '不能为空', trigger: 'blur' },
  ],
  addr: [
    { required: true, message: '不能为空', trigger: 'blur' },
  ],
}

// 监听表单数据变化
watch(() => props.form, (newVal) => {
  localForm.co_name = newVal.co_name
  localForm.corp_name = newVal.corp_name
  localForm.addr = newVal.addr
}, { immediate: true, deep: true })

// 监听本地表单数据变化，更新父组件数据
watch(localForm, (newVal) => {
  emit('update:form', {
    co_name: newVal.co_name,
    corp_name: newVal.corp_name,
    addr: newVal.addr,
  })
}, { deep: true })

// 表单ref，可以通过expose导出给父组件使用
const formRef = ref()

// 导出表单引用，供父组件调用表单验证方法
defineExpose({
  formRef,
})
</script>

<template>
  <el-form ref="formRef" :model="localForm" :rules="rules" label-width="90px">
    <el-form-item label="企业名称">
      <div>{{ localForm.co_name }}</div>
    </el-form-item>
    <el-form-item label="法定代表人" prop="corp_name">
      <el-input v-model="localForm.corp_name" placeholder="请输入法定代表人姓名" />
    </el-form-item>
    <el-form-item label="住所地" prop="addr">
      <el-input v-model="localForm.addr" placeholder="请输入住所地址" />
    </el-form-item>
  </el-form>
</template>

<style lang="scss" scoped>
</style>
